import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { UserCreationService } from '../../shared/user-creation.service';
import { ResponseType } from '@angular/http';



@Component({
  selector: 'app-area-creations',
  templateUrl: './area-creations.component.html',
  styleUrls: ['./area-creations.component.css']
})
export class AreaCreationsComponent implements OnInit {
  position = 'before';
  SUB_DIS_CODE(arg0: any): any {
    throw new Error("Method not implemented.");
  }
  ACODE: any;
  mode: any;
  dist: any;
  taluks: any;
  AreaCode:any={};
  officeList: any;
  data: any;
  area:any={};
  a:any={};

  constructor(private router:Router,private userCreationService:UserCreationService,private route: ActivatedRoute) { }

  ngOnInit() {
    this.getAreaCode();
    this.getAllTaluks();
    this.route.params.subscribe(params =>
      this.ACODE = params['ACODE']
      
    );
    this.route.params.subscribe(params =>
      this.mode = params['mode']
    );
    if (this.ACODE != null && this.mode!=null) 
      this.GetAreaForTheId(this.ACODE);
  }


  GetAreaForTheId(OfficeId) {
   
    // document.getElementById('loader-spinner').style.display = "block";
    this.userCreationService.GetAreaForTheId(OfficeId)
      .subscribe(
        (data) => {
          
          this.area=data;
          this.a=data;
          // this.AreaCode = data;
          //this.isUpdate=true;
          // document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          // document.getElementById('loader-spinner').style.display = "none";
          // this.errorHandler.HandlerError(error);
        });
  }

  update(form: NgForm) {
   debugger;
   form.value.DIS_CODE=this.area.DIS_CODE;
    form.value.ST_CODE=this.area.ST_CODE;
    this.userCreationService.updateArea(form.value,this.ACODE)
      .subscribe(
        (data) => {
         debugger;
          
          this.router.navigate(['/areacreationlist']);
        }, (error) => {
          
        });

  }

  onSubmit(form:NgForm){
    debugger;
    form.value.DIS_CODE=this.area.DIS_CODE;
    form.value.ST_CODE=this.area.ST_CODE;
    this.userCreationService.createArea(form.value)
    .subscribe(
      (data) => {
        alert("Inserted Successfully")
        //  swal('','Saved Successfully!','success');
        // this.router.navigate(['/home/rolesgrid']);
      }, (error) => {
        // alert(error.error.Message);
      });
  }

  getAllTaluks() {
    this.data = this.userCreationService.GetAllTaluks();
    this.data.subscribe(
      (response) => {
        this.taluks = response.TalukModel;

      }, (error) => {
      });
  }

  getAreaCode() {
    debugger;
    
    this.data = this.userCreationService.GetMaxAreaCode();
    this.data.subscribe(
      (response) => {
        this.a.ACODE= (response.AREACODE)+1;

      }, (error) => {
      });
  }

  getalldistrictdetails(SUB_DIS_CODE)
  {

    this.data = this.userCreationService.Getalldistrictdetails(SUB_DIS_CODE);

    this.data.subscribe(
      (response) => {
     this.area=response;
     
      }, (error) => {
        // this.errorHandler.HandlerError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/masters/area-creations/area-creations.component.ts